export const SUBTITLE =
  'We will pay $partner once we have had chance to review your satisfaction note.';
